import { ButtonGroup } from "@mui/material";
import { useWebStoreContext } from "contexts";
import { useClearAppPurchaseDataMutation } from "redux/apis";
import { useDialogModalRedux } from "redux/slices/dialog/hooks/useDialogModalRedux";
import ConfirmDialog from "../ConfirmDialog";

interface ClearAppPurchaseDataProps {
	showSuccessDialog: (success: boolean, title: string) => Promise<void>;
}

const ClearAppPurchaseData = ({
	showSuccessDialog
}: ClearAppPurchaseDataProps) => {
	const [clearAppPurchaseData, { isLoading }] =
		useClearAppPurchaseDataMutation();
	const { syncUserTracker } = useWebStoreContext();
	const { showErrorDialog } = useDialogModalRedux();

	const onClearAppPurchaseData = async () => {
		await clearAppPurchaseData("")
			.unwrap()
			.then(() => {
				showSuccessDialog(true, "Clear App Purchase Data");
				syncUserTracker();
			})
			.catch((error) => {
				showErrorDialog({
					data: {
						errorCode: error?.status?.toString(),
						errorMessage: error?.data?.error?.toString()
					}
				});
			});
	};

	return (
		<div>
			<ButtonGroup>
				<ConfirmDialog
					buttonText={"Clear App Purchase Data"}
					onClick={onClearAppPurchaseData}
					disabled={isLoading}
				/>
			</ButtonGroup>
		</div>
	);
};

export default ClearAppPurchaseData;
